export default {
  name: "HeartSolid",
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  path: {
    d:
      "M21.85 23.99c-2.03 1.52-3.95 2.95-5.05 4.39-.19.24-.47.38-.77.39-.3.01-.59-.13-.79-.36-1.16-1.4-3.02-2.78-4.98-4.24C5.55 20.67-.3 16.31 1.28 9.32c.75-3.31 3.66-6.01 6.79-6.29 1.84-.17 5.13.38 7.87 5.31 2.36-4.81 5.63-5.43 7.5-5.32 3.34.19 6.55 2.96 7.3 6.31 1.55 6.87-4.24 11.19-8.89 14.66z",
  },
}
